import { useCallback, useState } from 'react';
import _ from 'underscore';
import { useCustomer } from '@bingads-webui/overreact-cc';
import { usePromisify } from '@bingads-webui-react/overreact';
import {
  useCustomerLevelVariables,
  usePostponeReadVariables,
} from '@bingads-webui-campaign-react/basic-context-utils';

export const useLoadAndUpdateCustomerBusinessInfo = () => {
  const customerLevelVariables = useCustomerLevelVariables();
  const postponeReadConfig = usePostponeReadVariables();
  const [, { read: readCustomer, update: updateCustomer }] = useCustomer(customerLevelVariables, postponeReadConfig);
  const [
    readCustomerAsync, updateCustomerAsync,
  ] = usePromisify([readCustomer, updateCustomer]);
  const [customerData, setCustomerData] = useState({});

  const loadCustomerContactInfo = useCallback(() => readCustomerAsync({}).then((customer) => {
    const businessPhone = _.get(customer, ['BusinessPhone'], '');
    const businessName = _.get(customer, ['Name'], '');
    const customerId = _.get(customer, ['id'], '');

    const customerInfo = {
      phone: businessPhone,
      businessName,
      customerId,
      isValid: true,
    };

    setCustomerData(customer);
    return customerInfo;
  }), [readCustomerAsync]);

  const updateCustomerContactInfo = useCallback((contactInfo = {}) => {
    if (_.isEmpty(contactInfo)) {
      return Promise.resolve();
    }

    const updatedCustomerInfo = {
      ...(contactInfo.businessName ? { Name: contactInfo.businessName } : {}),
      ...(contactInfo.phone ? { BusinessPhone: contactInfo.phone } : {}),
    };

    if (_.isEmpty(updatedCustomerInfo)) {
      return Promise.resolve();
    }

    // no need to update if the business name and phone are the same
    if (_.get(customerData, ['BusinessPhone'], '') === contactInfo.phone &&
      _.get(customerData, ['Name'], '') === contactInfo.businessName) {
      return Promise.resolve();
    }

    return updateCustomerAsync({
      ...customerData,
      ...updatedCustomerInfo,
    })
      .then(() => {
        setCustomerData(prevState => ({
          ...prevState,
          BusinessPhone: contactInfo.phone,
          Name: contactInfo.businessName,
        }));
      })
      .catch((error) => {
        throw error;
      });
  }, [customerData, updateCustomerAsync]);

  return {
    loadCustomerContactInfo,
    updateCustomerContactInfo,
  };
};
